import * as ng from 'angular';
import * as _ from 'underscore';

import {AppEditorModel} from './app-editor.model';
import { AppStepType } from './app-templates';

interface PageOption {
   name:string;
   icon:string;
   type:AppStepType;
   enabled:boolean;
   youtubeTooltip?:boolean;
}

export class AppAddStepController {
   static $inject = ['$uibModalInstance', 'dialogs', 'model'];

   options:PageOption[];

   constructor(private $uibModalInstance, private dialogs, model:AppEditorModel) {
      this.options = [
         {
            name: 'Languages',
            icon: 'fa-globe',
            type: AppStepType.Languages,
            enabled: !pageExists(AppStepType.Languages) && model.languages.length > 1
         },
         {
            name: 'Form',
            icon: 'fa-file-text-o',
            type: AppStepType.Form,
            enabled: true
         },
         {
            name: 'Check-In',
            icon: 'fa-user-plus',
            type: AppStepType.CheckIn,
            enabled: !pageExists(AppStepType.QRScan, AppStepType.CheckIn)
         },
         {
            name: 'QR Lookup',
            icon: 'fa-qrcode',
            type: AppStepType.QRScan,
            enabled: !pageExists(AppStepType.QRScan, AppStepType.CheckIn)
         },
         {
            name: 'QR Assignment',
            icon: 'fa-qrcode',
            type: AppStepType.QRAssign,
            enabled: !pageExists(AppStepType.QRAssign) && pageExists(AppStepType.CheckIn)
         },
         {
            name: 'Photo Capture',
            icon: 'fa-camera',
            type: AppStepType.Photo,
            enabled: !pageExists(AppStepType.Photo, AppStepType.Video)
         },
         {
            name: 'Video Capture',
            icon: 'fa-video-camera',
            type: AppStepType.Video,
            enabled: !pageExists(AppStepType.Photo, AppStepType.Video) && model.youtubeConnected,
            youtubeTooltip: !model.youtubeConnected
         }
      ];

      function pageExists(...ids:AppStepType[]) {
         return _.any(model.pages, p => ids.indexOf(p.settings.type) !== -1);
      }
   }

   cancel() {
      this.$uibModalInstance.dismiss('cancel');
   }

   add(page) {
      // Show a message when adding a QR assign or lookup module
      if (page.type == AppStepType.QRScan || page.type == AppStepType.QRAssign) {
         let message = ['To use this feature at an event,'];

         // QR lookup
         if (page.type == AppStepType.QRScan) {
            message.push('it is recommended for the device to be connected');
            message.push('to the internet for the duration of the event.');
         }

         // QR assign
         if (page.type == AppStepType.QRAssign) {
            message.push('the event organizer will need to provide');
            message.push('physical cards with QR codes on them.');
         }

         message.push('Please contact your account representative for more info.');
         this.dialogs.alert(message.join(' '));
      }

      this.$uibModalInstance.close(page);
   };
}

ng.module('e360')
   .controller('AppAddStepController', AppAddStepController);
